import Vue from 'vue'
import VAd2  from './ad2'

export default VAd2




// WEBPACK FOOTER //
// ./src/components/index/mobile/ad2/index.js